module.exports = __webpack_public_path__ + "static/media/Sol.0e6e82fe.png";